export class Region {
	public value: string;
	public label: string;
    public id: string;
	public name: string;
	public displayName: string;
	public published: boolean;
	public workers: Array<{type: string, name: string, tags: Array<any>}>;
	public roles: Array<any>;
}